/* Copyright 2012-13 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "dijit/_WidgetBase",
    "dijit/_TemplatedMixin",
    "dijit/_Container",
    "dijit/popup",
    "./_WidgetMixin",
    "dojo/text!./templates/Footer.html"
], function (declare, _WidgetBase, _TemplatedMixin, _Container, popup, _WidgetMixin, template) {

    // TODO: Move this to domUtils
    var matchesSelector = function (node, selector) {
        var matchesMethod;

        if (!node || !selector || !(node instanceof Element)) {
            return false;
        }

        if (node.msMatchesSelector) {
            matchesMethod = "msMatchesSelector";
        } else {
            matchesMethod = "matches";
        }

        return node[matchesMethod](selector);
    };

    return declare([_WidgetBase, _TemplatedMixin, _Container, _WidgetMixin], {

        templateString: template,
        baseClass: "footer",

        postCreate: function () {
            this.inherited(arguments);

            /*
             * g1723480: List items didn't close a GalleryPopup on click, despite parent class MenuItem
             * supporting the property 'closeMenuOnClick'.  The 'closeRequest' logic does not bubble
             * up through the Footer and Gallery Popup, but the click does, so we listen to click and
             * if the item clicked is a ListItem, ListItemWithRadioButton, ListItemWithCheckBox,
             * MenuItem, RadioButtonMenuItem, or CheckBoxMenuItem, then we close the GalleryPopup.
             */
            this.own(
                this.on("click", function (e) {
                    /*
                     * CloseMenuOnClickMixin.js only adds the class 'mwClosePopupOnClick' to a widget
                     * that has the property 'closeMenuOnClick' set to true.  And it removes the class
                     * from a widget that has the property 'closeMenuOnClick' set to false.
                     */
                    if (matchesSelector(e.target, ".mwClosePopupOnClick, .mwClosePopupOnClick *")) {
                        // Close the parent if it is a GalleryPopup or a ComboBox Popup
                        // TODO: Update this logic to be mogre generalized
                        var parent = this.getParent();
                        if (parent.type === "GalleryPopup" || parent.domNode.classList.contains("mwComboBoxPopup")) {
                            popup.close(parent);
                        }
                    }
                }.bind(this))
            );
        }
    });
});
